import React      from 'react'
import { Link }   from 'react-router'
import classNames from 'classnames'

/**
 * A wrapper component for react-router links
 * @param   {Object}                  props   link properties
 * @return  {React.PropTypes.element} React   router Link
 */
const AnchorLink = (props) => {

  const { text, trackingName, dataRoute, classes, isRouterLink = true, to : href, children } = props
  /**
   * isRouterLink specifies if this link is react router link / external link
   *
   * react-router-link class signifies that this link is handled by reduxion app
   * Add any other classes as well. classNames module will strip off falsy
   * values by default.
   *
   */
  let allClasses = classNames(classes, { 'react-router-link' : isRouterLink } )

  if (isRouterLink) {
    return(
      <Link name={trackingName} className={allClasses} data-route={dataRoute || false} {...props}>{ children || text }</Link>
    )
  } else {
    return(
      <a name={trackingName} className={allClasses} data-route={dataRoute || false} href={href} {...props}>{ children || text }</a>
    )
  }
}

export default AnchorLink



/** WEBPACK FOOTER **
 ** ../app/components/common/AnchorLink.jsx
 **/